import { SortInfo } from '../entities/sort-info.entity';
import { SortOption } from '../entities/sort-option.entity';

export function SortOptionToSortInfo(sortOption: SortOption): SortInfo {
    return {
        field: sortOption.field,
        direction: sortOption.direction
    };
}
